import React from 'react';
import { useRoutes } from 'react-router-dom';

import { PersistGate } from 'redux-persist/integration/react';
import { persistor } from 'redux/store';
import { connect } from 'react-redux'

import { LoggedInOwnerRoutes, LoggedInAdminRoutes, LoggedInStandardRoutes, LoggedOutRoutes } from 'routes';
import { owner, admin, standard } from 'constants/userAccountTypes';

const mapStateToProps = (state) => ({
  activeUserId: state.activeUserId,
  activeUserType: state.activeUserType,
  authToken: state.authToken
});

function App(props) {

  const setRoutes = () => {
    if(props.authToken && props.activeUserId) {
      switch(props.activeUserType) {
        case owner:
          return LoggedInOwnerRoutes;
        case admin:
          return LoggedInAdminRoutes;
        case standard:
          return LoggedInStandardRoutes;
        default:
          return LoggedInStandardRoutes;
      }
    }
    else return LoggedOutRoutes;
  };
  
  const routing = useRoutes( setRoutes() );
  
  return (
    <PersistGate loading = {null} persistor = {persistor}>
      {routing}
    </PersistGate>
  )
};

export default connect (mapStateToProps) (App);